var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 61,
    viewBox: "0 0 44 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9307 54.4119C42.5575 54.4119 42.1842 54.0386 42.1842 53.6654V29.7772H34.7192C34.3459 29.7772 33.9727 29.4039 33.9727 29.0307C33.9727 28.6574 34.3459 28.2842 34.7192 28.2842H42.9307C43.304 28.2842 43.6772 28.6574 43.6772 29.0307V53.6654C43.6772 54.0386 43.304 54.4119 42.9307 54.4119Z",
    fill: "#525467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1996 35.7488C10.8264 35.7488 10.4531 35.3755 10.4531 35.0023V31.643C10.4531 31.2697 10.8264 30.8965 11.1996 30.8965H16.7984C17.1717 30.8965 17.5449 31.2697 17.5449 31.643C17.5449 32.0162 17.1717 32.3895 16.7984 32.3895H11.9461V34.629C11.9461 35.3755 11.5729 35.7488 11.1996 35.7488Z",
    fill: "#525467"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8043 60.011H9.70457C9.33132 60.011 8.95807 59.6377 8.95807 59.6377L0 39.4821C0 39.1088 0 38.7356 0 38.7356C0 38.3623 0.373253 38.3623 0.746506 38.3623H32.473C32.8462 38.3623 33.2195 38.7356 33.2195 38.7356L42.1776 58.8912C42.1776 59.2645 42.1776 59.6377 42.1776 59.6377C42.1776 60.011 42.1776 60.011 41.8043 60.011ZM10.4511 58.1447H40.3113L32.0997 39.8553H2.23952L10.4511 58.1447Z",
    fill: "#525467"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9709 34.6299H20.8931C20.5198 34.6299 20.1466 33.8834 20.1466 33.5102V12.2348H17.1606C16.7873 12.2348 16.4141 11.8615 16.4141 11.8615C16.4141 11.4883 16.4141 11.115 16.4141 10.7418L25.3721 0.290682C25.7454 -0.082571 26.4919 -0.082571 26.4919 0.290682L35.45 10.7418C35.8232 11.115 35.8232 11.4883 35.45 11.8615C35.45 12.2348 35.0767 12.2348 34.7034 12.2348H31.7174V33.5102C31.7174 33.8834 31.3442 34.6299 30.9709 34.6299ZM22.0129 32.7637H29.8512V11.115C29.8512 10.7418 30.2244 10.3685 30.5977 10.3685H32.4639L26.1186 2.15695L19.0268 10.3685H20.8931C21.2663 10.3685 21.6396 10.7418 21.6396 11.115V32.7637H22.0129Z",
    fill: "#525467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.85ed9ec80c6188f9c24f0f3a4ba57a59.svg";
export { ForwardRef as ReactComponent };